import {Component, effect, inject, input} from "@angular/core";
import {Title} from "@angular/platform-browser";

@Component({
  selector: "rf-page-title",
  templateUrl: "./page-title.html",
})
export class PageTitle {
  public readonly title = input.required<string>();

  public constructor() {
    const titleService = inject(Title);
    effect(() => titleService.setTitle(this.title()));
  }
}
